import { IDashboardFilterPayload } from '../model/summary';
import { useDashboardSummary } from '../service/summary.service';

export const useDashboardSummaryApplication = () => {
  const {
    getDashboardShipment,
    getDashboardChart,
    getDashboardDaily,
    getDashboardTopOrder,
  } = useDashboardSummary();

  async function handleGetDashboardShipment(payload: IDashboardFilterPayload) {
    return getDashboardShipment(payload);
  }

  async function handleGetDashboardChart(payload: IDashboardFilterPayload) {
    return getDashboardChart(payload);
  }

  async function handleGetDashboardDaily(payload: IDashboardFilterPayload) {
    return getDashboardDaily(payload);
  }

  async function handleGetDashboardTopOrder(payload: IDashboardFilterPayload) {
    return getDashboardTopOrder(payload);
  }

  return {
    handleGetDashboardShipment,
    handleGetDashboardChart,
    handleGetDashboardDaily,
    handleGetDashboardTopOrder,
  };
};

export default useDashboardSummaryApplication;
